import { FC, useEffect, useState } from 'react';
import { ProductionOrders, QualityMeasure } from '../../TimeGrid.types';
import dayjs from 'dayjs';
import { Bubble, ModulesIcon } from '../Bubble/Bubble';

export interface QualityMeasuresProps {
  containerRef: React.RefObject<HTMLDivElement>;
  qualityMeasures: QualityMeasure[];
  timezone: string;
  hours: number[];
  startAtProductions?: ProductionOrders[];
  heightRow: number;
  heightMinutes: number;
  onClick?: (id: number) => void;
}

const WIDTH_FIRST_COLUMN = 50;
const TOTAL_MINUTES = 60;
const GAP_BETWEEN_ROWS = 2;

export const QualityMeasures: FC<QualityMeasuresProps> = ({
  containerRef,
  qualityMeasures,
  timezone,
  hours,
  startAtProductions,
  heightRow,
  heightMinutes,
  onClick,
}) => {
  const sizeIcon = heightRow * 0.6;
  const [divs, setDivs] = useState<JSX.Element[]>([]);

  const getWidthPerMinute = (container: HTMLDivElement) => {
    const row = container.querySelector('.cells.row');
    if (row) {
      const cells = row.querySelectorAll('.cell.data');
      let sumaWidth = 0;
      cells.forEach((cell) => {
        sumaWidth += cell.getBoundingClientRect().width;
      });
      return sumaWidth / TOTAL_MINUTES;
    }
    return 0;
  };

  useEffect(() => {
    if (containerRef.current) {
      const widthPerMinute = getWidthPerMinute(containerRef.current);
      const getLeftPosition = (currentMin: number) => {
        return currentMin * widthPerMinute + WIDTH_FIRST_COLUMN - sizeIcon / 2;
      };

      let positionLeftUsed: { hour: number; left: number }[] = startAtProductions
        ? startAtProductions.map((p) => {
            const hour = dayjs(p.startAt).tz(timezone).hour();
            const left = getLeftPosition(dayjs(p.startAt).minute());
            return { hour, left };
          })
        : [];
      const newDivs = [...qualityMeasures]
        .sort((a, b) => a.registeredAtInMillis - b.registeredAtInMillis)
        .map((quality, index) => {
          const currentDate = dayjs(quality.registeredAtInMillis).tz(timezone);

          const currentHour = currentDate.hour();
          const indexHour = hours.findIndex((hour) => hour === currentHour);
          const top = heightMinutes + indexHour * heightRow + indexHour * GAP_BETWEEN_ROWS;

          let left = getLeftPosition(currentDate.minute());
          while (
            positionLeftUsed.some(
              (p) => p.hour === currentHour && Math.abs(left - p.left) < sizeIcon
            )
          ) {
            left += sizeIcon;
          }
          positionLeftUsed.push({ hour: currentHour, left });
          positionLeftUsed = positionLeftUsed.sort((a, b) => a.left - b.left);
          return (
            <div
              key={index}
              style={{
                position: 'absolute',
                top,
                left,
                zIndex: 2,
                display: 'flex',
                alignItems: 'center',
                height: heightRow,
              }}
            >
              <Bubble
                module={
                  quality.sourceType === 'manual' ? ModulesIcon.qualityManual : ModulesIcon.quality
                }
                color={quality.isAccepted ? 'success' : 'danger'}
                onClick={() => onClick && onClick(quality.id)}
                className="quality-measure-bubble-icon"
                size={sizeIcon}
              />
            </div>
          );
        });
      setDivs(newDivs);
    }
  }, [containerRef.current?.clientHeight, qualityMeasures]);

  return <div className="no-grid">{divs}</div>;
};
